import { Option } from 'shared/form/select/option.interface';

export const assetTypeLookup: Array<Option> = [
  {
    'option': '',
    'title': '-'
  },
  {
    'option': 'P04',
    'title': 'Photo-primary'
  },
  {
    'option': '360',
    'title': '360 degree image set'
  },
  {
    'option': 'APG',
    'title': 'Application guide'
  },
  {
    'option': 'AUD',
    'title': 'Audio file'
  },
  {
    'option': 'BRO',
    'title': 'Brochure'
  },
  {
    'option': 'BUL',
    'title': 'Technical bulletin'
  },
  {
    'option': 'BUY',
    'title': 'Buyers guide'
  },
  {
    'option': 'CAS',
    'title': 'Case study'
  },
  {
    'option': 'CAT',
    'title': 'Catalog'
  },
  {
    'option': 'CER',
    'title': 'Certificate of origin'
  },
  {
    'option': 'DAS',
    'title': 'Datasheet'
  },
  {
    'option': 'DRW',
    'title': 'Technical drawing'
  },
  {
    'option': 'EBK',
    'title': 'Ebook'
  },
  {
    'option': 'FAB',
    'title': 'Features and benefits'
  },
  {
    'option': 'FED',
    'title': 'Full engineering drawing'
  },
  {
    'option': 'HMS',
    'title': 'Hazardous material info sheet'
  },
  {
    'option': 'HOT',
    'title': 'Image Hotspotting'
  },
  {
    'option': 'INS',
    'title': 'Installation instructions '
  },
  {
    'option': 'ISG',
    'title': 'Illustration guide'
  },
  {
    'option': 'LIN',
    'title': 'Line art'
  },
  {
    'option': 'LGO',
    'title': 'Logo image'
  },
  {
    'option': 'MSD',
    'title': 'Material safety data sheet'
  },
  {
    'option': 'OWN',
    'title': 'Owner\'s manual'
  },
  {
    'option': 'P01',
    'title': 'Photo-out of package'
  },
  {
    'option': 'P02',
    'title': 'Photo-in package'
  },
  {
    'option': 'P03',
    'title': 'Photo-lifestyle view'
  },
  {
    'option': 'P05',
    'title': 'Photo-close up'
  },
  {
    'option': 'P06',
    'title': 'Photo-mounted'
  },
  {
    'option': 'P07',
    'title': 'Photo-unmounted'
  },
  {
    'option': 'PAG',
    'title': 'Link to manufacturer page',
  },
  {
    'option': 'PAL',
    'title': 'Pallet configuration drawing'
  },
  {
    'option': 'PDB',
    'title': 'Product brochure '
  },
  {
    'option': 'PC1',
    'title': 'Planogram consumer pack 1 '
  },
  {
    'option': 'PC2',
    'title': 'Planogram consumer pack 2'
  },
  {
    'option': 'PC3',
    'title': 'Planogram consumer pack 3'
  },
  {
    'option': 'PI1',
    'title': 'Planogram inner pack 1'
  },
  {
    'option': 'PI2',
    'title': 'Planogram inner pack 2'
  },
  {
    'option': 'PI3',
    'title': 'Planogram inner pack 3'
  },
  {
    'option': 'PP1',
    'title': 'Planogram case pack 1'
  },
  {
    'option': 'PP2',
    'title': 'Planogram case pack 2'
  },
  {
    'option': 'PP3',
    'title': 'Planogram case pack 3'
  },
  {
    'option': 'PSS',
    'title': 'Product specifications sheet'
  },
  {
    'option': 'PST',
    'title': 'Price sheet'
  },
  {
    'option': 'RES',
    'title': 'Research bullentin'
  },
  {
    'option': 'RGL',
    'title': 'Regulatory Content Label'
  },
  {
    'option': 'SPE',
    'title': 'Specification sheet filename'
  },
  {
    'option': 'THU',
    'title': 'Thumbnail'
  },
  {
    'option': 'TON',
    'title': 'Tone art'
  },
  {
    'option': 'VGL',
    'title': 'General Information Video'
  },
  {
    'option': 'VID',
    'title': 'Primary Video'
  },
  {
    'option': 'VIN',
    'title': 'Installation Video'
  },
  {
    'option': 'VLF',
    'title': 'Lifestyle Video'
  },
  {
    'option': 'VMC',
    'title': 'Maintenance Care Video'
  },
  {
    'option': 'WAR',
    'title': 'Warranty'
  },
  {
    'option': 'WHP',
    'title': 'Whitepaper'
  },
  {
    'option': 'ZZ1',
    'title': 'User 1'
  },
  {
    'option': 'ZZ2',
    'title': 'User 2'
  },
  {
    'option': 'ZZ3',
    'title': 'User 3'
  },
  {
    'option': 'ZZ4',
    'title': 'User 4'
  },
  {
    'option': 'ZZ5',
    'title': 'User 5'
  },
  {
    'option': 'ZZ6',
    'title': 'User 6'
  },
  {
    'option': 'ZZ7',
    'title': 'User 7'
  },
  {
    'option': 'ZZ8',
    'title': 'User 8'
  },
  {
    'option': 'ZZ9',
    'title': 'User 9'
  }
];
export const thirdPartyAssetTypeLookup: Array<Option> = [
  {
    'option': '',
    'title': '-'
  },
  {
    'option': '360',
    'title': '360 degree image set'
  },
  {
    'option': 'HOT',
    'title': 'Image Hotspotting'
  },
  {
    'option': 'PAG',
    'title': 'Link to manufacturer page',
  },
  {
    'option': 'VGL',
    'title': 'General Information Video'
  },
  {
    'option': 'VID',
    'title': 'Primary Video'
  },
  {
    'option': 'VIN',
    'title': 'Installation Video'
  },
  {
    'option': 'VLF',
    'title': 'Lifestyle Video'
  },
  {
    'option': 'VMC',
    'title': 'Maintenance Care Video'
  },
  {
    'option': 'INS',
    'title': 'Installation Instructions'
  },
  {
    'option': 'ISG',
    'title': 'Installation Instructions'
  },
  {
    'option': 'ZZ1',
    'title': 'User 1'
  },
  {
    'option': 'ZZ2',
    'title': 'User 2'
  },
  {
    'option': 'ZZ3',
    'title': 'User 3'
  },
  {
    'option': 'ZZ4',
    'title': 'User 4'
  },
  {
    'option': 'ZZ5',
    'title': 'User 5'
  },
  {
    'option': 'ZZ6',
    'title': 'User 6'
  },
  {
    'option': 'ZZ7',
    'title': 'User 7'
  },
  {
    'option': 'ZZ8',
    'title': 'User 8'
  },
  {
    'option': 'ZZ9',
    'title': 'User 9'
  },
];

export const representationLookup: Array<Option> = [
  {
    'option': '',
    'title': '-'
  },
  {
    'option': 'A',
    'title': 'Actual product'
  },
  {
    'option': 'R',
    'title': 'Representative of product'
  }
];

export const fileTypeLookup: Array<Option> = [
  { 'option': 'TIF', 'title': 'TIF' },
  { 'option': 'JPG', 'title': 'JPG' },
  { 'option': 'EPS', 'title': 'EPS' },
  { 'option': 'TXT', 'title': 'TXT' },
  { 'option': 'FLV', 'title': 'FLV' },
  { 'option': 'F4V', 'title': 'F4V' },
  { 'option': 'AVI', 'title': 'AVI' },
  { 'option': 'WEBM', 'title': 'WEBM' },
  { 'option': 'OGV', 'title': 'OGV' },
  { 'option': 'MP4', 'title': 'MP4' },
  { 'option': 'MKV', 'title': 'MKV' },
  { 'option': 'AIF', 'title': 'AIF' },
  { 'option': 'WAV', 'title': 'WAV' },
  { 'option': 'WMA', 'title': 'WMA' },
  { 'option': 'OGG', 'title': 'OGG' },
  { 'option': 'PCM', 'title': 'PCM' },
  { 'option': 'AC3', 'title': 'AC3' },
  { 'option': 'MIDI', 'title': 'MIDI' },
  { 'option': 'MP3', 'title': 'MP3' },
  { 'option': 'AAC', 'title': 'ACC' },
  { 'option': 'GIF', 'title': 'GIF' },
  { 'option': 'BMP', 'title': 'BMP' },
  { 'option': 'PNG', 'title': 'PNG' },
  { 'option': 'PDF', 'title': 'PDF' },
  { 'option': 'DOC', 'title': 'DOC' },
  { 'option': 'XLS', 'title': 'XLS' }
];

export const colorModeLookup: Array<Option> = [
  { 'option': 'RGB', 'title': 'RGB' },
  { 'option': 'CMY', 'title': 'CMYK' },
  { 'option': 'GRA', 'title': 'Gray Scale' },
  { 'option': 'OTH', 'title': 'Other' },
  { 'option': 'WEB', 'title': 'Vector B/W' },
  { 'option': 'VEC', 'title': 'Vector Color' },
  { 'option': 'BIT', 'title': 'Bitmap' }
];

export const resolutionLookup: Array<Option> = [
  {
    'option': 72,
    'title': 72
  },
  {
    'option': 96,
    'title': 96
  },
  {
    'option': 300,
    'title': 300
  },
  {
    'option': 600,
    'title': 600
  },
  {
    'option': 800,
    'title': 800
  },
  {
    'option': 1200,
    'title': 1200
  }
];

export const backgroundLookup: Array<Option> = [
  {
    'option': 'WHI',
    'title': 'White'
  },
  {
    'option': 'CLI',
    'title': 'White w/clipping path'
  },
  {
    'option': 'TRA',
    'title': 'Transparent'
  },
  {
    'option': 'OTH',
    'title': 'Other'
  }
];

export const orientationViewLookup: Array<Option> = [
  {
    'option': 'ANG',
    'title': 'Angle'
  },
  {
    'option': 'BAC',
    'title': 'Back'
  },
  {
    'option': 'BOT',
    'title': 'Bottom'
  },
  {
    'option': 'CON',
    'title': 'Connector'
  },
  {
    'option': 'FRO',
    'title': 'Front'
  },
  {
    'option': 'KIT',
    'title': 'Kit'
  },
  {
    'option': 'LEF',
    'title': 'Left'
  },
  {
    'option': 'LIF',
    'title': 'Lifestyle'
  },
  {
    'option': 'NUL',
    'title': 'Not applicable'
  },
  {
    'option': 'OTH',
    'title': 'Other'
  },
  {
    'option': 'RIT',
    'title': 'Right'
  },
  {
    'option': 'SID',
    'title': 'Side'
  },
  {
    'option': 'TOP',
    'title': 'Top'
  },
  {
    'option': 'ZZ1',
    'title': 'User 1'
  },
  {
    'option': 'ZZ2',
    'title': 'User 2'
  },
  {
    'option': 'ZZ3',
    'title': 'User 3'
  },
  {
    'option': 'ZZ4',
    'title': 'User 4'
  },
  {
    'option': 'ZZ5',
    'title': 'User 5'
  },
  {
    'option': 'ZZ6',
    'title': 'User 6'
  },
  {
    'option': 'ZZ7',
    'title': 'User 7'
  },
  {
    'option': 'ZZ8',
    'title': 'User 8'
  },
  {
    'option': 'ZZ9',
    'title': 'User 9'
  }
];

export const assetUomLookup: Array<Option> = [
  {
    'option': 'px',
    'title': 'Pixels'
  },
  {
    'option': 'in',
    'title': 'Inches'
  },
  {
    'option': 'cm',
    'title': 'Centimeters'
  }
];
